import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ palette, spacing, breakpoints }: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: palette.background.paper,
    overflow: 'hidden',
    [breakpoints.up('sm')]: {
      borderTopRightRadius: spacing(1),
      borderTopLeftRadius: spacing(1),
    },
  },
  tab: {
    minWidth: 'auto',
    padding: 0,
    margin: spacing(2.5),
    minHeight: spacing(2),
  },
  tabsFlexContainer: {
    gap: spacing(4),
  },
  tabIndicator: {
    backgroundColor: palette.success.main,
  },
}));
